<template>
  <div id="sign-up" class="container mt-5">
    <form @submit.prevent="logIn">
      <div class="form-group">
        <label for="email">Email Address:</label>
        <input
          v-model="emailInput"
          type="email"
          class="form-control"
          id="email"
          placeholder="Enter Your Email"
        />
      </div>
      <div class="form-group">
        <label for="password">Password:</label>
        <input
          v-model="passwordInput"
          type="password"
          class="form-control"
          id="password"
          placeholder="Enter Your Password"
        />
      </div>
      <button
        :disabled="!isFormValid"
        type="submit"
        class="btn btn-primary btn-block"
      >
        Sign In
      </button>
      <p class="mt-1">
        Don't have an account?
        <router-link to="/register">Sign Up</router-link>.
      </p>
    </form>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'Login',
  data() {
    return {
      emailInput: '',
      passwordInput: ''
    }
  },
  methods: {
    logIn() {
      const { emailInput, passwordInput } = this
      firebase
        .auth()
        .signInWithEmailAndPassword(emailInput, passwordInput)
        .then(
          user => {
            localStorage.setItem('uid', user.user.uid)
            localStorage.setItem('email', user.user.email)
            this.$router.go({ path: 'this.$router.path' })
            this.$router.push({ path: '/courses' })
          },
          err => {
            alert(err.message)
          }
        )
    }
  },
  computed: {
    isFormValid() {
      const { emailInput, passwordInput } = this

      return emailInput && passwordInput
    }
  }
}
</script>

<style lang="scss" scoped></style>
